<template>
  <div class="provider" :class="{ '-active': active }" @click="toggleProvider">
    <div class="provider__content" :class="{ '-filter': isFilter }">
      <img
        v-if="provider.image || error"
        loading="lazy"
        :class="{ '-filter': isFilter }"
        class="provider__img"
        :src="image"
        :alt="provider.name"
        @error="errorImage"
      />
      <div v-else class="provider__name">
        <span class="ellipsis">{{ provider.name }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { cdnDomain } from 'src/common/functions'

const props = defineProps({
  provider: {
    type: Object,
    required: true,
  },
  isFilter: Boolean,
  active: Boolean,
})

const emit = defineEmits(['toggle'])

const error = ref(false)

const image = computed(() => {
  const rawUrl = props.provider.image.startsWith('/') ? props.provider.image.slice(1) : props.provider.image
  return cdnDomain + rawUrl
})

function errorImage() {
  error.value = true
}

function toggleProvider() {
  emit('toggle', props.provider)
}
</script>

<style scoped lang="scss">
.provider {
  position: relative;
  width: 100%;
  color: var(--cas-light-700);
  transition: all 0.2s;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 46.2%;
  user-select: none;

  &__content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--cas-main-deep-2);
    transition: all 0.2s;
    border-radius: 4px;

    &.-filter {
      border: 1px solid rgba(255, 255, 255, 0.14);
    }
  }

  &__img {
    height: 100%;
    object-fit: contain;
    object-position: center;
    width: 100%;
    pointer-events: none;

    &.-filter {
      max-height: 90%;
      max-width: 90%;
    }
  }

  &__name {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      display: block;
      text-align: center;
    }
  }

  &:hover {
    .provider__content {
      &.-filter {
        background-color: rgba(255, 255, 255, 0.07);
      }
    }
  }

  &.-active {
    z-index: 1;

    .provider__content {
      border-color: var(--cas-secondary);
      background-color: rgba(255, 255, 255, 0.07);
    }

    &:hover {
      &::before {
        content: '';
        position: absolute;
        background: var(--cas-secondary);
        opacity: 0.3;
        left: -3px;
        right: -3px;
        bottom: -3px;
        top: -3px;
        border-radius: 5px;
        z-index: -1;
      }

      &::after {
        content: '';
        z-index: -1;
        position: absolute;
        background: var(--cas-main-deep-2);
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        border-radius: 4px;
      }
    }
  }
}
</style>
